import { render, staticRenderFns } from "./nxService.vue?vue&type=template&id=6e40742a&scoped=true&"
import script from "./nxService.vue?vue&type=script&lang=js&"
export * from "./nxService.vue?vue&type=script&lang=js&"
import style0 from "./nxService.vue?vue&type=style&index=0&id=6e40742a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.10.1_sqwtrzbl6s4ypz4dmnoirtpj7i/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e40742a",
  null
  
)

export default component.exports